import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IExamStatsByQuestionBySkill } from "../../../models/statistics.model";
import { ApexOptions } from 'apexcharts';
import Chart from 'react-apexcharts';

interface IProps {
  data: IExamStatsByQuestionBySkill[]|undefined;
}

const ExamQuestioneGraph: FC<IProps> = ({
  data
}) => {
  const { t } = useTranslation();
  let series: ApexOptions['series'] = [];
  let options: ApexOptions = {};

  if(data) {
    series = [
      {
        name: 'Average',
        data: data.map((value) => {
          return {x:value.skillName , y:Math.floor(Number(value.correctAnswerRate) * 10) / 10};
        }).sort(
          function (a,b) {
            return  b.y - a.y;
          }
        ),
        group: 'Average',
      },
    ];

    options = {
      chart: {
        type: 'bar',
        stacked: true,
        toolbar: { show: false },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            total: {
              enabled: false,
            },
          },
        },
      },
      xaxis: {
        max: 100,
      },
      yaxis: {
        
        labels: {
          minWidth:0,
          maxWidth:300,
          align:'right',
          offsetY:8
        }
        
      },
      legend: {
        position: 'bottom',
        show: true,
        showForSingleSeries: true
      },
      dataLabels: { enabled: true },
      colors: ["#697480"]
    };
  }

  return data?.length
    ? (
      <div style={{ width: '100%', height: '70vh' }}>
        <Chart series={series} options={options} type="bar" height="100%" />
      </div>
      )
    : null
}

export default ExamQuestioneGraph;
